<template>
  <div class="l-main-content">
    <div class="p-team-user">
      <div class="c-title">
        <div class="c-title__text">チームユーザーの一覧</div>
        <div class="c-text">
          <a :href="teamData.userAddLinkUrl">チームユーザーを追加する</a>
        </div>
      </div>
      <div class="p-team-user__data">
        <table class="c-table">
          <thead class="c-table__head--gray">
            <tr>
              <th class="u-w150">名前</th>
              <th class="u-w250">メールアドレス（ログインID）</th>
              <th class="u-w250">ログインできるプロジェクト</th>
              <th class="u-w140">権限</th>
              <th></th>
            </tr>
          </thead>
          <tbody v-for="accountUser in accountUsers" :key="accountUser.user_id">
            <tr @click="onClickEdit(accountUser.user_id)">
              <td>{{ accountUser.user_name}}</td>
              <td>{{ accountUser.login_id }}</td>
              <td>
                <span v-for="(accountUserService, loopIndex1) in accountUser.account_user_services" :key="loopIndex1">
                  <span v-show="accountUserService.service.delete_flag == 0">{{ accountUserService.service.service_name }}<br /></span>
                </span>
              </td>
              <td>{{ teamData.userRoleTypes[accountUser.user_role] }}</td>
              <td>
                <template v-if="accountUser.contractor_flag == 1">ご契約者様</template>
                <a
                  v-else
                  class="p-team-user__btn-delete"
                  href="#del"
                  :data-id="accountUser.user_id"
                  :data-name="accountUser.user_name"
                  :data-email="accountUser.login_id"
                  @click="onClickDeleteUser(accountUser, $event)"
                >削除する</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- モーダル: ユーザー削除確認 -->
    <control-modal
      ref="refControlModal"
      classes="c-modal--team"
      title="下記ユーザーを削除してもよろしいですか？"
      :body="deleteUserData"
      cancel-button-label="キャンセル"
      enter-button-label="削除する"
      :is-active=isDeleteUser
      :is-body-html=true
      :on-close-click="onCloseConrolModal"
      :on-cancel-click="onCloseConrolModal"
      :on-enter-click="onEnterConrolModal"
    />
    <!-- /モーダル: ユーザー削除確認 -->
  </div>
</template>

<script>
import axios from 'axios';
export default {
  props: {
    teamData: Object,
  },
  data: function () {
    return {
      accountUsers: null,
      deleteUserId: null,
      deleteUserData: '',
      isDeleteUser: false,
    }
  },
  mounted: function () {
    this.accountUsers = this.teamData.accountUsers;
  },
  methods: {
    // -----------------------------------------------------------------------------------------------------
    // イベント系メソッド一覧: UI操作にフックしてコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    onClickDeleteUser: function (accountUser, event) {
      event.stopPropagation();
      this.isDeleteUser = true;
      this.deleteUserId = accountUser.user_id;
      this.deleteUserData = '<ul class="c-modal-list">'
        + `<li class="c-modal-list__item">${accountUser.user_name}</li>`
        + `<li class="c-modal-list__item">${accountUser.login_id}</li>`
        + '</ul>'
    },
    onClickEdit: function(userId) {
      location.href = '/coins-admin/team/edituser/' + userId;
    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: 操作モーダルを閉じる処理
    onCloseConrolModal() {
      this.isDeleteUser = false;
      this.$refs.refControlModal.resetErrorMessage();
    },

    // クリック: 操作モーダルのENTER処理
    onEnterConrolModal() {
      // 操作用モーダルのボタンローダーを表示
      this.$refs.refControlModal.showLoader();

      // フォーム要素取得
      const data = {
        userId: this.deleteUserId,
      };

      // チームユーザーデータの取得処理実行
      axios.post('/api/team/delete', data)
        .then(res => {
          // 削除処理成功
          // レスポンスのステータスコード = 成功 && レスポンス文字列 = OK
          if(res.data.result == 'OK'){
            this.accountUsers.forEach((accountUser, index) => {
              if(accountUser.user_id == this.deleteUserId) {
                this.accountUsers.splice(index, 1);
              }
            });
            this.$refs.refControlModal.hideLoader();
            this.isDeleteUser = false;
            this.deleteUserId = null;
            this.errorMessage = '';

            // 削除処理成功に見えた失敗
            // レスポンスのステータスコードが成功 && レスポンス文字列がOKではない場合
          } else {
            this.$refs.refControlModal.hideLoader();
            this.$refs.refControlModal.showErrorMessage(
              (res.data.message)
                ? res.data.message
                : 'ユーザーの削除に失敗しました'
            );
          }
        })
        .catch(error => {
          if(error.response) {
            if(error.response.status == 401){
              location.href = "/coins-admin";
              return;
            }
          }
          this.$refs.refControlModal.hideLoader();
          this.$refs.refControlModal.showErrorMessage('ユーザーの削除に失敗しました');
        });
    },
  },
}
</script>
